/*jshint browserify: true */
/*global PDFedit*/
'use strict';

module.exports = TestHomeCtrl;

TestHomeCtrl.$inject = ['$http', '$scope'];

function TestHomeCtrl($http, $scope) {
    /* jshint validthis:true */
    var vm = this;
    vm.pdfElementSettings = PDFedit.elements.PdfElement;
    vm.addTextModeSettings = PDFedit.uimodes.AddTextMode.colourSettings;
    vm.deleteElements = deleteElements;
    vm.document = null;
    vm.scale = '1.5';
    vm.interactionMode = 'SelectionMode';
    vm.pdfRenderApi = {};
    vm.pdfElements = [];
    vm.selectedPdfElements = [];
    vm.loadStyleInput = '';
    Object.defineProperty(vm, 'showTextEditor', {
        get: function () {
            return vm.selectedPdfElements.length === 1 && vm.selectedPdfElements[0] instanceof PDFedit.elements.PdfTextElement;
        }
    });
    Object.defineProperty(vm, 'textCharacterSpacing', {
        get: function () {
            if (vm.selectedPdfElements.length === 1 && vm.selectedPdfElements[0] instanceof PDFedit.elements.PdfTextElement) {
                var retval = '';
                for (var i = 0; i < vm.selectedPdfElements[0].characterSpacings.length; i++) {
                    if (retval.length > 0) {
                        retval += ', ';
                    }
                    retval += vm.selectedPdfElements[0].characterSpacings[i];
                }
                return retval;
            } else {
                return '';
            }
        },
        set: function (newVal) {
            if (newVal === '') {
                vm.selectedPdfElements[0].characterSpacings = [];
            } else {
                var newVals = newVal.split(',');
                for (var i = 0; i < newVals.length; i++) {
                    newVals[i] = Number(newVals[i]);
                    if (isNaN(newVals[i])) {
                        newVals[i] = 0;
                    }
                }

                vm.selectedPdfElements[0].characterSpacings = newVals;
            }
        }
    });

    activate();

    function activate() {
        $http.get('form6.pdf', { responseType: 'arraybuffer' }).then(function (response) {
            vm.document = new Uint8Array(response.data);
        });
    }

    function deleteElements() {
        vm.pdfRenderApi.deleteSelectedElements();
    }
}